import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import lastOperationsIcon from './../../../img/last-operations-icon.png';
import { newRequest, request } from './../../../../../config';
import YesNoModal from '../../../../../copms/Modal/YesNoModal';
import Loading from '../../../Loading/Loading';

class TemplatesVisaPlus extends Component {
    state = {
        open: false,
        operations: [],
        cards: [],
        cardId: null,
        mobile: '',
        uuid: null
    }

    deleteTemplate() {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        fetch(newRequest(`visa/api/ads/templates/${this.state.uuid}`, null, 'DELETE'))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(response.status.statusCode), null, null, () => this.getTemplates());
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            });
    }

    componentWillMount() {
        // this.setState({ isLoading: true });
        // if (localStorage.getItem('custObject')) {
        //     let custObject = JSON.parse(localStorage.getItem('custObject'));
        //     let mobile = (custObject.customer !== undefined) ? custObject.customer.mobile : custObject.mobile;
        //     if (mobile !== null && mobile !== undefined) {
        //         mobile = '+' + mobile.slice(0, 3) + ' (' + mobile.slice(3, 5) + ') ' + mobile.slice(5, 8) + '-' + mobile.slice(8, 10) + '-' + mobile.slice(10, 12);
        //     }
        //     this.setState({ mobile });
        // }
        this.getTemplates();
    }

    getTemplates = () => {
        this.setState({ isLoading: true })
        fetch(newRequest("visa/api/ads/templates", null, "GET"))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode), null, true);
                    }
                }
                else {
                    this.setState({ templates: response.templates || [], isLoading: false });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    createAlias = () => {
        this.setState({ isLoading: true });
        let requestBody = {
            cardId: this.state.cardId,
        }
        fetch(newRequest("visa/api/ads/aliases", requestBody, "POST"))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(response.status.statusCode), null, null, () => this.props.history.push("/dashboard/transfer/visa-plus"));
                }
            },
                (error) => {

                    this.props.history.push("/technical-break");
                });
    }

    getVisaDirectCardList = () => {
        let requestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            custId: localStorage.getItem('custId')
        }
        fetch(request("card/getVisaDirectCardList", requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1 && response.status.statusCode !== 137) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    if (response.status.statusCode === 137) {
                        response.cardList = [];
                    }
                    this.setState({ cards: response.cardList, isLoading: false });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    // componentDidMount() {
    // }

    render() {
        let { t } = this.props;
        let { open, templates, isLoading, isCardToCard } = this.state;
        return (
            <Fragment>
                <YesNoModal
                    title={t("Are you sure you want to delete the template?")}
                    open={open} onClose={() => this.setState({ open: false })} triggerFunc={() => this.deleteTemplate()} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => (this.props.history.goBack(), this.setState({ isCardToCard: !isCardToCard }))}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Visa+ money transfers')}</h2>
                    </div>
                </div>
                {isLoading ?
                    <div className="dashboard-container-main-section">
                        <Loading />
                    </div>
                    :
                    <div className="dashboard-container-main-section">
                        <div className="dashboard-account-container dashboard-container-main-section-home-left mw-100 bg-white">
                            <div className="dashboard-account-container-component">
                                <h3>{t('Templates')}</h3>
                                <div className="dashboard-new-transfer-section-content-visa-plus-templates">
                                    {templates.length > 0 && templates.map((template, index) =>
                                        <div className="dashboard-new-transfer-section-content-visa-plus-templates-item">
                                            <ul>
                                                <li className='dashboard-new-transfer-section-content-visa-plus-templates-item-icon-section'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M15.8333 17.5V15.8333C15.8333 14.9493 15.4821 14.1014 14.857 13.4763C14.2319 12.8512 13.384 12.5 12.5 12.5H7.49999C6.61593 12.5 5.76809 12.8512 5.14297 13.4763C4.51785 14.1014 4.16666 14.9493 4.16666 15.8333V17.5" stroke="#6A7282" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M9.99999 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99999 2.5C8.15904 2.5 6.66666 3.99238 6.66666 5.83333C6.66666 7.67428 8.15904 9.16667 9.99999 9.16667Z" stroke="#6A7282" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                    <span>{template?.name}</span>
                                                </li>
                                                <li className='dashboard-new-transfer-section-content-visa-plus-templates-item-icon-section'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M17.4068 13.2667V15.7667C17.4077 15.9988 17.3602 16.2285 17.2672 16.4411C17.1742 16.6538 17.0379 16.8447 16.8668 17.0016C16.6958 17.1585 16.4939 17.2779 16.2741 17.3523C16.0542 17.4266 15.8213 17.4542 15.5901 17.4333C13.0258 17.1547 10.5626 16.2785 8.39844 14.875C6.38496 13.5956 4.67789 11.8885 3.39844 9.875C1.99009 7.701 1.11364 5.22583 0.840107 2.65C0.819283 2.41956 0.84667 2.1873 0.920524 1.96802C0.994379 1.74874 1.11308 1.54724 1.26908 1.37635C1.42508 1.20546 1.61494 1.06892 1.8266 0.975434C2.03825 0.881945 2.26706 0.833551 2.49844 0.833333H4.99844C5.40286 0.829352 5.79493 0.972565 6.10158 1.23628C6.40822 1.49999 6.6085 1.8662 6.66511 2.26667C6.77063 3.06672 6.96632 3.85227 7.24844 4.60833C7.36056 4.9066 7.38483 5.23076 7.31836 5.5424C7.2519 5.85404 7.09749 6.14009 6.87344 6.36667L5.81511 7.425C7.0014 9.51129 8.72882 11.2387 10.8151 12.425L11.8734 11.3667C12.1 11.1426 12.3861 10.9882 12.6977 10.9217C13.0093 10.8553 13.3335 10.8795 13.6318 10.9917C14.3878 11.2738 15.1734 11.4695 15.9734 11.575C16.3782 11.6321 16.7479 11.836 17.0122 12.1479C17.2765 12.4598 17.4169 12.858 17.4068 13.2667Z" stroke="#6A7282" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                    <span>{template?.aliasValue}</span>
                                                </li>
                                                <li className='dashboard-new-transfer-section-content-visa-plus-templates-item-icon-section'>
                                                    <span>{t('Amount')}:</span>
                                                    <span>{template?.amount} {template?.currency}</span>
                                                </li>
                                                <li className='dashboard-new-transfer-section-content-visa-plus-templates-item-icon-section'>
                                                    <button onClick={() => this.props.history.push(`/dashboard/transfer/visa-plus/templates/${template?.uuid}`)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M12.1133 18.0716C12.145 18.1505 12.2 18.2179 12.2711 18.2646C12.3421 18.3113 12.4257 18.3352 12.5107 18.333C12.5957 18.3308 12.678 18.3027 12.7465 18.2524C12.8151 18.2021 12.8666 18.1321 12.8942 18.0516L18.3108 2.2183C18.3375 2.14446 18.3426 2.06455 18.3255 1.98793C18.3084 1.9113 18.2699 1.84113 18.2144 1.78561C18.1588 1.7301 18.0887 1.69154 18.012 1.67446C17.9354 1.65737 17.8555 1.66246 17.7817 1.68913L1.94834 7.1058C1.86792 7.13338 1.79787 7.1849 1.74757 7.25344C1.69728 7.32199 1.66915 7.40428 1.66698 7.48926C1.6648 7.57425 1.68867 7.65787 1.73539 7.7289C1.78211 7.79993 1.84944 7.85497 1.92834 7.88663L8.53668 10.5366C8.74558 10.6203 8.93539 10.7453 9.09465 10.9043C9.25391 11.0633 9.37933 11.2529 9.46334 11.4616L12.1133 18.0716Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M18.2117 1.78906L9.095 10.9049" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        <span>Köçürmə et</span>
                                                    </button>
                                                    <button onClick={() => this.setState({ open: true, uuid: template?.uuid })}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M2.5 5H17.5" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M15.8334 5V16.6667C15.8334 17.5 15 18.3333 14.1667 18.3333H5.83335C5.00002 18.3333 4.16669 17.5 4.16669 16.6667V5" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M6.66669 5.00008V3.33341C6.66669 2.50008 7.50002 1.66675 8.33335 1.66675H11.6667C12.5 1.66675 13.3334 2.50008 13.3334 3.33341V5.00008" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M8.33331 9.16675V14.1667" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M11.6667 9.16675V14.1667" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-currency-convertor-calendar-section bg-white">
                            <div className="dashboard-finance-section-card-section-details-section-header">
                                <h3 className="dashboard-finance-section-card-section-details-section-header-title dashboard-last-operations-section-header-title">{t('How are money transfers made via Visa+?')}</h3>
                            </div>
                            <div className="dashboard-last-operations-section-content">
                                <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image w-75" alt="lastOperationsIcon" />
                                <p className="dashboard-last-operations-section-content-status">{t('visa+ text')}</p>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default translate("translation")(TemplatesVisaPlus);